import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isError, isPlainObject } from "lodash";

interface ErrorModalParam {
  errorMessage: string;
  headline: string;
  paragraph: string;
  type: "print" | "default";
}

interface ErrorState {
  hasError: boolean;
  errorMessage?: string;
  stack?: string;
  modal?: ErrorModalParam;
  modalIsOpen?: boolean;
}

const initialState: ErrorState = {
  hasError: false,
  errorMessage: undefined,
  stack: undefined,
  modal: undefined,
  modalIsOpen: false
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Error | string | { message: string; stack: string }>) => {
      // Never overwrite previous error
      if (state.hasError) {
        return;
      }

      const error = action.payload;
      const fallbackErrorMessage = "Es ist ein unbekannter Fehler aufgetreten.";

      if (isError(error)) {
        state.hasError = true;
        state.errorMessage = error.message || fallbackErrorMessage;
        state.stack = error.stack || "";
      } else if (isPlainObject(error)) {
        state.hasError = true;
        state.errorMessage = (error as any).message || fallbackErrorMessage;
        state.stack = (error as any).stack || JSON.stringify(error, null, 2);
      } else {
        state.hasError = true;
        state.errorMessage = error ? String(error) : fallbackErrorMessage;
        state.stack = "";
      }
    },
    reset: state => {
      state.hasError = false;
      state.errorMessage = undefined;
      state.stack = undefined;
    },
    setModal: (state, action: PayloadAction<{ error: ErrorModalParam }>) => {
      state.modal = action.payload.error;
    },
    resetModal: state => {
      state.modal = undefined;
    },
    setModalIsOpen: (state, action: PayloadAction<{ isOpen: boolean }>) => {
      state.modalIsOpen = action.payload.isOpen;
    }
  }
});

export default errorSlice;
